import React, { useState, useEffect } from 'react'
import { T, Spinner, Empty, Avatar, inGameFilter } from '../ui'
import { getNFLFades } from '../api'
import { playText, teamNick } from '../plain'

// FADES — the "the over is a trap" lens. Two-way props where the model fades the over, so the UNDER
// is the value (a −EV over = a +EV under). Ranked by under-edge. Amber/red theme to separate it
// from the green value/locks boards. Research only — it names the number to fade, not a wager.
const edgeColor = e => (e >= 8 ? T.red : e >= 4 ? T.amber : T.muted)

export default function FadesTab({ season = 2026, week = 1, onPlayer, gameFilter, embedded }) {
  const [d, setD] = useState(null)
  useEffect(() => { let a = true; setD(null)
    getNFLFades(season, week).then(r => { if (a) setD(r) }); return () => { a = false } }, [season, week])

  if (!d) return <Spinner />
  const rows = (d.fades || []).filter(r => inGameFilter(gameFilter, r.team))
  return (
    <div style={{ padding: embedded ? '0' : '10px 14px 80px' }}>
      <div style={{ background: T.card, border: `1px solid ${T.border}`, borderLeft: `3px solid ${T.amber}`,
        borderRadius: 11, padding: '11px 13px', marginBottom: 12, fontSize: 12, color: T.muted2, lineHeight: 1.5 }}>
        <b style={{ color: T.amber }}>The overs that are traps.</b> Two-way props where the book hung the number
        too high, so the <b style={{ color: T.text }}>under is the value</b>. <b style={{ color: T.text }}>+edge</b> = the under beats the price.
      </div>
      {rows.length === 0
        ? <Empty message="No favorable unders yet — fills once book lines post." />
        : rows.map((r, i) => {
          const pct = Math.round((r.prob || 0) * 100)
          return (
            <button key={i} onClick={() => onPlayer && onPlayer({ full_name: r.name, pos: r.pos, team: r.team,
              opp: r.opp, prop_type: r.prop_type, market: r.market, ...(r.gsis_id ? { gsis_id: r.gsis_id } : {}), status: 'active' })}
              style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%',
                textAlign: 'left', cursor: 'pointer', background: T.card, border: `1px solid ${T.border}`,
                borderRadius: 11, padding: '12px 14px', marginBottom: 8, color: T.text }}>
              <span style={{ display: 'flex', alignItems: 'center', gap: 11, minWidth: 0 }}>
                <span style={{ fontFamily: T.mono, fontSize: 12, fontWeight: 800, color: T.faint, width: 18 }}>{i + 1}</span>
                <Avatar url={r.headshot} name={r.name} team={r.team} size={36} />
                <span style={{ minWidth: 0 }}>
                  <span style={{ display: 'block', fontSize: 15, fontWeight: 800 }}>{r.name}</span>
                  <span style={{ display: 'block', fontSize: 11.5, color: T.muted, fontWeight: 600 }}>
                    {teamNick(r.team)} vs {teamNick(r.opp)} · <b style={{ color: T.amber }}>{playText(r.market, r.line, 'under')}</b></span>
                </span>
              </span>
              <span style={{ textAlign: 'right', flexShrink: 0 }}>
                <span style={{ display: 'block', fontFamily: T.mono, fontSize: 19, fontWeight: 900, color: edgeColor(r.edge_pct || 0) }}>+{r.edge_pct}</span>
                <span style={{ display: 'block', fontSize: 10, color: T.faint, fontWeight: 700 }}>{pct}% under</span>
              </span>
            </button>
          )
        })}
      <div style={{ fontSize: 10, color: T.faint, marginTop: 10, lineHeight: 1.5 }}>
        <b style={{ color: T.amber }}>UNDER</b> = the model says bet the under · +edge vs the no-vig fair · informational only · 21+.
      </div>
    </div>
  )
}
